import React, { useEffect, useState } from "react";
import "./Style/AssessmentComplete.css"
import bg from "./Image/blank_background.png"
import { useNavigate, useSearchParams } from "react-router-dom";
import Loading from "../../Common/Loading";

interface AssessmentData {
  LoggedName: string;
  Message: string;
  LogoClass: string;
  GetStarted: string;
  RedirectUrl: string;
  error?: string;
}

const AssessmentComplete: React.FC = () => {
  const [data, setData] = useState<AssessmentData | null>(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const reportNo = searchParams.get("ReportNo") || "0";
  const calledFrom = searchParams.get("CalledFrom") || "";
  // console.log("reportNo:", reportNo);
  // console.log("calledFrom:", calledFrom);
    const apiUrl =
    process.env.REACT_APP_DOCUMENT_LINK ;

  const requestBody = {
    SchoolCode: sessionStorage.getItem("SchoolCode"),
    FamilyCode: sessionStorage.getItem("FamilyCode"),
    Login: sessionStorage.getItem("Login"),
    ReportNo: reportNo,
    CalledFrom: calledFrom
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(`${apiUrl}assessment-complete/`, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify(requestBody),
        });

        const result = await response.json();
        setData(result);
        // console.log("Fetched data:", result);
      } catch (err) {
        // console.error("Error fetching data:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, []);

  const handleFinishClick = () => {
    // console.log("Finish button clicked");
    // console.log("calledFrom:", calledFrom.split("~")[1]);
    navigate("/STUDENT/MSR/StudyRoom?Subject=Mathematics&lastPage=Assessment");
  };

//   const handleFinishClick = () => {
//   const urlParams = new URLSearchParams(window.location.search);
//   const nameParam = urlParams.get("name");
//   let calledFrom = null;
 

//   if (nameParam && nameParam.includes("calledFrom=")) {
//     const decodedName = decodeURIComponent(nameParam);
//     calledFrom = decodedName.split("calledFrom=")[1];
//   }
 
//   console.log("calledFrom:", calledFrom);
 
//   // if (window.confirm('Are you sure you want to quit the Test?')) {
//   //       if (calledFrom) {
//   //           window.location.href = calledFrom;
//   //       } else if (window.history.length > 1) {
//   //           window.history.back();
//   //       }
//   // }
// };

  const handleContinueClick = () => {
    const queryString = `?ReportNo=${encodeURIComponent(reportNo)}&CalledFrom=${encodeURIComponent(calledFrom)}`;
    navigate(`/MathsDoctor/Assessment/AssessmentComplete${queryString}`);
  };

  if (loading) return <tr><td colSpan={100}><Loading /></td></tr>;;
  if (!data) return <div>Error loading data.</div>;
  if (data.error) return <div>{data.error}</div>;

  return (
     <div  style={{ backgroundImage: `url(${bg})`, backgroundSize: "cover", backgroundRepeat: "no-repeat", position:"absolute",width:"100vw",height:"100vh" }}>
    <form id="form1T" style={{ backgroundImage: `url(${bg})` }}>
      <div id="completion_container">
        <div id="divLoggedName">{data.LoggedName}</div>
      </div>

      <div id="completion_content_box">
        <div id="completion_content">
          <div id="completion_text_box">
            <p className="completion_title">ASSESSMENT COMPLETE!</p>
            <p className="completion_text">
              <br />
              <span id="spanText">{data.Message}</span>
              <br />
              <br />
              <span id="spanGetStarted" className="completion_orange">
                {data.GetStarted}
              </span>
              <br />
              <br />
            </p>

            <div id="bok_finish_line"></div>

            <div id="buttons_box">
              {/* <button
                type="button"
                id="linkbtnFinish"
                className="finish_btn1"
                onClick={handleFinishClick}
              >
                Finish
              </button> */}
                                  <a id="linkbtnFinish" className="finish_btn1T" onClick={handleFinishClick}
                    // style={{border: 'none', color:'white', textDecoration: 'none', backgroundColor: 'transparent', cursor: 'pointer', textAlign: 'end'}}
                    >
                    </a>
            </div>
          </div>
        </div>
      </div>

      <div id="divLogo" className={data.LogoClass}></div>
    </form></div>
  );
};

export default AssessmentComplete;
